import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HandledHttpResponse, httpRetry } from '@uzenith360/http-utils';
import { JwtInterface } from '@uzenith360/jwt-utils';
import { Observable, catchError, of, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { httpRunner } from '@uzenith360/http-utils';

@Injectable({
  providedIn: 'root'
})
export class PinUpdateService {

  constructor(private http: HttpClient) { }

  updatePin(
    newPin: string,
    oldPin?: string,
  ): Observable<HandledHttpResponse<JwtInterface>> {
    const body: { [key: string]: string | number } = {
      newPin,
    };

    if(!!oldPin) {
      body['oldPin'] = oldPin;
    }

    return httpRunner(this.http.patch(`${environment.usersBaseUrl}/photographers/pin`, body));
  }
}
